import React from 'react';
import { Button } from './Button';

const Modal = ({ message, onClose, children, maxWidthClass = "max-w-sm" }) => {
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div className={`bg-white p-6 rounded-lg shadow-lg ${maxWidthClass} w-full`}>
                {/* Modal Header */}
                <h2 className="text-xl font-semibold text-center mb-4">{message}</h2>

                {/* Modal Body (Custom Content) */}
                {children}

                {/* Modal Footer (Close Button) */}
                <div className="flex justify-center mt-4">
                    <Button
                       onClick={onClose}
                    >
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
